import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconSave: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8888 0H1C0.447716 2.41411e-08 0 0.447716 0 1V13C8.33928e-08 13.5523 0.447716 14 1 14H13C13.5516 13.9985 13.9985 13.5516 14 13V3.11125L10.8888 0ZM2.5 4.5V2.5H8.5V4.5H2.5ZM9.49719 10.1175V10.1175C9.43233 11.4967 8.2617 12.5622 6.88252 12.4973C5.50333 12.4325 4.43785 11.2618 4.50271 9.88264C4.5633 8.59412 5.59429 7.56325 6.88281 7.50281C8.26581 7.44192 9.43631 8.5137 9.4972 9.8967C9.50044 9.97026 9.50043 10.0439 9.49719 10.1175L9.49719 10.1175Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconSave.defaultProps = iconDefaultProps;
IconSave.displayName = 'IconSave';

export default IconSave;
